import { useState } from 'react';
import { useBi, useTranslation } from '@wix/yoshi-flow-editor';
import { memberWebAppButtonClick as memberWebAppButtonClickV2 } from '@wix/bi-logger-challenges-member-web/v2';
import { State as ParticipantState } from '@wix/ambassador-challenges-v1-participant/types';
import { isHiddenPlansOnly } from '@wix/challenges-web-library';
import { SelectedPaymentOption } from '../../../../ChallengesPage/Widget/components/Pricing/interfaces';
import { getChallengeEligiblePaidPlans } from '../../../../ChallengesPage/Widget/components/Pricing/helpers/getChallengeEligiblePaidPlans';
import { useUser } from '../../../../../contexts/User/UserContext';
import { ButtonNames } from '../../../../../contexts/main/biInterfaces';
import { useToast } from '../../../../../contexts/ToastContext/ToastContext';
import { ToastType } from '../../../../../contexts/ToastContext/interfaces';
import { getPricingViewOptions } from '../../../../../services/getPricingViewOptions';
import { useChallengeData } from '../../../../../contexts/storage-contexts/Challenge';
import { useMemberPaidPlans } from '../../../../../contexts/storage-contexts/PaidPlans';

export const useProgramRejoin = () => {
  const { t } = useTranslation();
  const bi = useBi();
  const { showToast } = useToast();
  const { userType, join } = useUser();
  const {
    challengeData: { challenge },
  } = useChallengeData();
  const { userPaidPlans, eligiblePlans } = useMemberPaidPlans();
  const [selectedPaymentOption, setSelectedPaymentOption] =
    useState<SelectedPaymentOption>(null);

  const { isHasSinglePayment, challengePaidPlans } = getPricingViewOptions(
    challenge,
    userPaidPlans,
    eligiblePlans,
    false,
    false,
  );
  const hasEligiblePaidPlan = getChallengeEligiblePaidPlans(
    eligiblePlans,
    userPaidPlans,
    challenge.id,
  ).length;
  const isHiddenPaidPlanOnly =
    !hasEligiblePaidPlan &&
    isHiddenPlansOnly(isHasSinglePayment, challengePaidPlans);

  const renewParticipation = async () => {
    await bi.report(
      memberWebAppButtonClickV2({
        buttonName: ButtonNames.RenewParticipation,
      }),
    );

    if (isHiddenPaidPlanOnly) {
      showToast(t('toast.error.contact-site-owner'), {
        type: ToastType.error,
      });
      return;
    }

    join(selectedPaymentOption, null);
  };

  return {
    isSuspended: userType === ParticipantState.SUSPENDED,
    selectedPaymentOption,
    setSelectedPaymentOption,
    renewParticipation,
  };
};
